import { render, staticRenderFns } from "./SocialApp.vue?vue&type=template&id=b79f4400&"
import script from "./SocialApp.vue?vue&type=script&lang=js&"
export * from "./SocialApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports